import React from "react";
import { fabric } from "fabric";
import { Checkbox } from "@material-ui/core";
import { useAuth } from "../../../../contexts/AuthContext";
import { useSelector } from "react-redux";

const SharpenOptions = ({ save, saveBack }) => {
  const { currentUser } = useAuth();
  const _home = useSelector((state) => state.home);

  const applyFilter = (index, filter) => {
    var obj = _home.currentCanvas.getActiveObject();
    if (obj) {
      obj.filters[index] = filter;
      obj.applyFilters();
      _home.currentCanvas.requestRenderAll();
    }
    if (currentUser) {
      if (_home.face === "front") {
        save();
      } else {
        saveBack();
      }
    }
  };

  const applySharpen = (check) => {
    applyFilter(
      12,
      check &&
        new fabric.Image.filters.Convolute({
          matrix: [0, -1, 0, -1, 5, -1, 0, -1, 0],
        })
    );
  };

  return (
    <div>
      Sharpen:
      <Checkbox
        color="primary"
        onClick={(e) => applySharpen(e.target.checked)}
        inputProps={{ "aria-label": "secondary checkbox" }}
      />
    </div>
  );
};

export default SharpenOptions;
